import { useEffect, useState } from 'react'

const ZENDESK_SNIPPET_URL = 'https://static.zdassets.com/ekr/snippet.js?key=154ebc60-273e-4071-9019-8256b676ba2b'

type Props = {
  orderableName: string
  userId: number | string
  userEmail: string
}

export const ZendeskWidget: React.FC<Props> = ({ orderableName, userId, userEmail }) => {
  const [zendeskReady, setZendeskReady] = useState(false)

  const onZendeskReady = () => {
    if (!window.zE) return

    window.zE('webWidget', 'setLocale', 'ja')
    window.zE('webWidget', 'prefill', { email: { value: userEmail } })

    window.zE('webWidget:on', 'userEvent', (event: any) => {
      if (event.action === 'Contact Form Shown') {
        const displayFields = ['メールアドレス', '説明', '添付ファイル']
        const iframe = document.getElementById('webWidget') as HTMLIFrameElement

        if (!iframe?.contentDocument) return

        iframe.contentDocument.querySelectorAll('[data-garden-id="forms.field"]').forEach((element: HTMLElement) => {
          const label = element.querySelector('label')
          if (!label) return

          const labelText = label.innerText
          if (!displayFields.some((field) => labelText.includes(field))) {
            element.style.display = 'none'
          }

          if (labelText === '説明') {
            if (element.innerText.includes('あわせて「よくある質問」もご覧ください')) return

            const br = document.createElement('br')
            const link = document.createElement('a')
            link.href = '/faq'
            link.target = '_blank'
            link.textContent = 'あわせて「よくある質問」もご覧ください'

            const hintContainer = element.querySelector('[data-garden-container-id="containers.field.hint"]')
            if (hintContainer) {
              hintContainer.append(br, link)
            }
          }
        })
      }
    })

    setZendeskReady(true)
  }

  useEffect(() => {
    if (zendeskReady && window.location.hash === '#inquiry') {
      window.zE('webWidget', 'open')
      window.location.hash = ''
    }
  }, [window.location.hash, zendeskReady])

  useEffect(() => {
    window.zESettings = {
      webWidget: {
        contactForm: {
          fields: [
            {
              id: 13554664146201, // 商品名
              prefill: { '*': orderableName },
            },
            {
              id: 360017725233, // ユーザID
              prefill: { '*': userId && +userId },
            },
          ],
          ticketForms: [
            {
              id: 360000685053, // FLOWERフォーム
              subject: false,
              fields: [
                {
                  id: 'description',
                  hint: {
                    '*': '届いた商品の不備についてお問い合わせの場合は、お手数ですが写真をご用意ください💁‍♀',
                  },
                },
              ],
            },
          ],
        },
      },
    }

    const script = document.createElement('script')
    script.id = 'ze-snippet'
    script.src = ZENDESK_SNIPPET_URL
    script.async = true
    script.addEventListener('load', onZendeskReady)

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [orderableName, userId, userEmail])

  return null
}
